var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.045 5.401c.378-.378.586-.88.586-1.414 0-.534-.208-1.036-.586-1.414L13.459.987a1.986 1.986 0 0 0-1.414-.586c-.534 0-1.036.208-1.413.585L0 11.585V16h4.413L15.045 5.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM2 14v-1.585l7.04-7.018 1.586 1.586L3.587 14H2zm-2 4h16v2H0v-2z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8f96515e64455d48d54dd89c2278a1ee.svg";
export { ForwardRef as ReactComponent };